export function mapPossibleActionToOptions(possibleActions = []) {
  return possibleActions
    .filter(opt => opt.can_view)
    .map(opt => {
      return {
        value: opt.Action.action_code,
        label: opt.Action.action_label,
        isdisabled: !opt.can_execute
      }
    })
}
